export const BOOKING_URL = "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5575618&share=true&pId=3089459";

export const NAV_ITEMS = [
  { id: "#top", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { id: "#contact", label: "Contact" },
];

const img = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: img("photo-1745327883508-b6cd32e5dde5", 1200),
  touch: img("photo-1519823551278-64ac92734fb1"),
  leavesShadow: img("photo-1578583316094-043603e4386c"),
  leaves: img("photo-1497250681960-ef046c08a56e"),
  forestLight: img("photo-1509423350716-97f9360b4e09"),
  interior: img("photo-1600210492486-724fe5c67fb0"),
  interiorWood: img("photo-1615529182904-14819c35db37"),
  linen: img("photo-1519710164239-da123dc03ef4"),
  therapist: "/images/elena.jpg",
  treatments: [
    img("photo-1745327883508-b6cd32e5dde5", 800),
    img("photo-1519824145371-296894a0daa9", 800),
    img("photo-1519823551278-64ac92734fb1", 800),
    img("photo-1596178060671-7a80dc8059ea", 800),
  ],
};

export const SERVICES = [
  {
    cat: "massage",
    featured: true,
    title: "Integrated Therapeutic Massage",
    tag: "Signature Massage",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5575618&oiid=sv%3A29166822&share=true&pId=3089459",
    durShort: "60–120 MIN",
    dur: "60 · 75 · 90 · 120 MIN",
    desc: "A blend of deep tissue work, myofascial techniques, acupressure, dynamic cupping and hot stones for a deeply relaxing and restorative massage experience.",
    prices: [[60, 120], [75, 145], [90, 175], [120, 225]],
  },
  {
    cat: "massage",
    title: "Swedish Relaxation Massage",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5575618&oiid=sv%3A29166821&share=true&pId=3089459",
    durShort: "45–120 MIN",
    dur: "45 · 60 · 75 · 90 · 120 MIN",
    desc: "Long, flowing strokes and gentle pressure help the body unwind into deep physical and mental relaxation.",
    prices: [[45, 95], [60, 115], [75, 140], [90, 165], [120, 220]],
  },
  {
    cat: "massage",
    featured: true,
    title: "Deep Tissue Massage",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5575618&oiid=sv%3A29166820&share=true&pId=3089459",
    durShort: "45–120 MIN",
    dur: "45 · 60 · 75 · 90 · 120 MIN",
    desc: "Targets deeper layers of muscle and connective tissue to release tension and ease muscular discomfort.",
    prices: [[45, 95], [60, 115], [75, 140], [90, 165], [120, 220]],
  },
  {
    cat: "massage",
    title: "Dynamic Cupping Massage",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5575618&oiid=sv%3A29166819&share=true&pId=3089459",
    durShort: "60–90 MIN",
    dur: "60 · 75 · 90 MIN",
    desc: "Moving cups glide across the skin, creating gentle suction that works with the muscles and fascia to ease tension, encourage circulation, and improve mobility.",
    prices: [[60, 120], [75, 150], [90, 175]],
  },
  {
    cat: "massage",
    title: "Hot Stone Massage",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5575618&oiid=sv%3A29166818&share=true&pId=3089459",
    durShort: "60–120 MIN",
    dur: "60 · 75 · 90 · 120 MIN",
    desc: "Massage with smooth, heated stones brings deep, soothing warmth, softening tight muscles and allowing stress to gradually melt away.",
    prices: [[60, 145], [75, 175], [90, 210], [120, 245]],
  },
  {
    cat: "esthetics",
    featured: true,
    title: "Royal Signature Facial",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5612305&oiid=sv%3A29360546&share=true&pId=3089459",
    dur: "90 MIN",
    desc: "A restorative treatment designed to enhance radiance and reveal fresh, luminous skin with a dedicated 30-minute lymphatic drainage massage. Cleansing, exfoliation, a mask, hydration and advanced skin technologies leave the skin refreshed, smooth and deeply nourished.",
    prices: [[90, 200]],
  },
  {
    cat: "esthetics",
    title: "Royal Signature Back Treatment",
    bookUrl: "https://www.fresha.com/book-now/royal-essence-massage-h71wrnnr/services?lid=3194168&eid=5612305&oiid=sv%3A29360568&share=true&pId=3089459",
    dur: "90 MIN",
    desc: "A signature treatment designed to nurture the skin, complemented by a dedicated 30-minute upper body massage. Deep cleansing, exfoliation, a mask, targeted skin care and advanced skin technologies leave the skin soft, smooth and hydrated.",
    prices: [[90, 175]],
  },
];

export const CONTACT = {
  phone: "(780) 902-4049",
  email: "info@royalessencemassage.com",
  venue: "NOWi Aesthetics Post-Op Recovery Health Spa",
  address: "4606B 99 St NW, Room 2, Edmonton, AB T6E 5H5",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=4606B+99+St+NW+Edmonton+AB+T6E+5H5",
  mapEmbed: "https://www.google.com/maps?q=4606B+99+St+NW,+Edmonton,+AB+T6E+5H5&output=embed",
};
